module.exports = __webpack_public_path__ + "img/Barakat-w.ff6c81dd.png";